/** Determine if x is "semi strictly equal" to y (x === y except for null and undefined). */
export function semiStrictEquals<A>(x: A, y: A): boolean {
  return (x ?? null) === (y ?? null);
}

export function semiStrictIncludes<A>(x: A[], y: A): boolean {
  return x.some(x => semiStrictEquals(x, y));
}
